import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShoppingCartCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6288 17.8014C14.2738 17.8014 13.986 17.5136 13.986 17.1586C13.986 16.8036 14.2738 16.5157 14.6288 16.5157C14.9839 16.5157 15.2717 16.8036 15.2717 17.1586C15.2717 17.5136 14.9839 17.8014 14.6288 17.8014Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.27176 17.8014C5.91673 17.8014 5.62891 17.5136 5.62891 17.1586C5.62891 16.8036 5.91673 16.5157 6.27176 16.5157C6.62681 16.5157 6.91462 16.8036 6.91462 17.1586C6.91462 17.5136 6.62681 17.8014 6.27176 17.8014Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.19861 1.0872H4.41289L4.75124 4.30148M4.75124 4.30148L5.57744 12.1504C5.64632 12.8047 6.19811 13.3015 6.85609 13.3015H14.9804C15.5705 13.3015 16.0847 12.9 16.2278 12.3276L17.835 5.89903C18.0379 5.08756 17.4241 4.30148 16.5876 4.30148H4.75124Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.80994 9.12303L10.5242 10.4087L13.3367 7.19445",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgShoppingCartCheck;
